import {
  ActionProcessMode,
  IContextMenuItemRefreshRules,
  THotKey,
} from '@infotech-soe/metaschema';

import { ClientContext } from '../../context/IContextService';
import { DatasetGridRow } from '../../dataset/view-model/DatasetGridRow';
import { CommandName } from '../CommandViewModel';
import { UserInteractor, UserInteractorType } from '../UserInteractor';
import { RefreshStrategy } from '../wrap/CategoryCommand';

abstract class CategoryCommandImpl<T> {
  public abstract execute(
    context: ClientContext,
    args: T
  ): Promise<void | Record<string, any>>;

  public abstract getInitialArgs(
    context: ClientContext,
    currentRecord?: DatasetGridRow
  ): Promise<T>;

  public abstract getName(): CommandName;

  // TODO: this has to be async
  public isAvailable(context: ClientContext): boolean {
    const processMode = this.getProcessMode();
    if (processMode === 'Any') {
      return true;
    } else if (processMode === 'Current') {
      const id = context.get('Id');
      if (id === undefined) {
        return false;
      }
      const selected = context.get('SelectedIds');
      return (
        !selected ||
        selected.length === 0 ||
        (selected.length === 1 && selected[0] === id)
      );
    } else {
      return context.has('Id');
    }
  }

  public getHotKey(): THotKey | undefined {
    return;
  }

  public getUserInteractor(): UserInteractor {
    return {
      type: UserInteractorType.NONE,
    };
  }

  public getRefreshStrategy(): RefreshStrategy {
    return RefreshStrategy.NONE;
  }

  public getRefreshRules(): IContextMenuItemRefreshRules | undefined {
    return undefined;
  }

  public getProcessMode(): ActionProcessMode {
    return 'Any';
  }

  public getBadge(_context: ClientContext): string | number | undefined {
    return undefined;
  }

  public getMenuLabel(): string | undefined {
    return undefined;
  }
}

export default CategoryCommandImpl;
